module.exports = __webpack_public_path__ + "img/not-authorized-dark.cb9b7e17.svg";